import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Image } from "react-konva";
import { attachAccessory } from "../../actions/endcap-actions";
import { getScaledValue } from "../../actions/calculations-actions";
import ManifoldService from "../../lib/services/manifold-service";
import { CHAMBER_TYPE_ID_SC160LP } from "../../lib/types";
const flampImgURL = require("../../media/flamp.svg");
const flampImg160URL = require("../../media/flamp160.svg");
const flampImg = new window.Image();
flampImg.src = flampImgURL;
const flamp160Img = new window.Image();
flamp160Img.src = flampImg160URL;

class Flamp extends PureComponent {
    render() {
        if (this.props.active) {
            let showFlamp = this.props.accessory && this.props.accessory.id !== null;
            const chamberTypeId = this.props.chamberType.id;
            const isUpper = (this.props.position === 'ENDCAP_POSITION_UPPER');

            let flampX, flampY, fixX, fixY;
            let flampHeight = this.props.height / 1.5; // OK
            let flampWidth = this.props.width * 1.3; // OK
            let img = flampImg;

            switch (chamberTypeId) {
                case "MC-7200":
                    fixX = isUpper ? 25.15 : 25;
                    fixY = isUpper ? 80 : 80;
                    break;
                case "MC-4500":
                    // On isUpper Higher fixX moves it to the RIGHT
                    // On NOT isUpper Higher fixX moves it to the LEFT
                    fixX = isUpper ? 25 : 25; // OK : OK

                    // On isUpper Higher fixY moves it to the TOP
                    // On NOT isUpper Higher fixY moves it to the BOTTOM
                    fixY = isUpper ? 51 : 50; // OK : OK
                    break;
                case "C-100HD":
                    fixX = isUpper ? 22 : 22; // OK
                    fixY = isUpper ? 90 : 90; // OK
                    flampHeight = this.props.height / 1.5;
                    flampWidth = this.props.width * 1.3;
                    break;
                case "DC-780":
                    fixX = isUpper ? 10 : 10; // OK
                    fixY = isUpper ? 90 : 90; // OK
                    flampHeight = this.props.height / 1.2; // OK
                    flampWidth = this.props.width * 2.5; // OK
                    break;
                case 'SC-740':
                    fixX = isUpper ? 10 : 10; // OK
                    fixY = isUpper ? 90 : 90; // OK
                    flampHeight = this.props.height / 1.2; // OK
                    flampWidth = this.props.width * 2.5; // OK
                    break;
                case 'SC-310':
                    fixX = isUpper ? 4 : 6; // OK
                    fixY = isUpper ? 90 : 90; // OK
                    flampHeight = this.props.height / 1.2; // OK
                    flampWidth = this.props.width * 2.5; // OK
                    break;
                case 'SC-160LP':
                    fixX = isUpper ? 8 : 6; // OK
                    fixY = isUpper ? 90 : 90; // OK
                    flampHeight = this.props.height / 1.2; // OK
                    flampWidth = this.props.width * 2.5; // OK
                    showFlamp = false;
                    break;
                default:
                    break;
            }

            flampY = this.props.chamberWidth - this.props.getScaledValue(fixY / 12);
            flampX = this.props.chamberHeight - this.props.getScaledValue(fixX / 12);

            if (!this.props.accessory) showFlamp = false;

            if (!showFlamp && this.props.mainManifolds) {
                try {
                    showFlamp = chamberTypeId === CHAMBER_TYPE_ID_SC160LP
                        ? false
                        : ManifoldService.isChamberConnectedToSecondDirectPipe(
                            this.props.chamberRows[this.props.row],
                            this.props.chamberRows[this.props.row].chambers[this.props.col],
                            isUpper,
                            this.props.mainManifolds
                                .filter(m => {
                                    return m._letRow === this.props.row && (isUpper ? !m.isUpper : m.isUpper);
                                }),
                        );
                } catch (e) {
                    showFlamp = false;
                }
            }

            return (
                // flampsX and Y are inverted to mak it easy to position
                showFlamp && null/*<Image
                    id={`${this.props.row}-${this.props.col}-${this.props.position}-1`}
                    name="flamp"
                    image={this.props.isIsolator ? img : null}
                    height={flampHeight}
                    width={flampWidth}
                    ref={node => {
                        this.endcapNode = node;
                    }}
                    rotation={270}
                    x={flampY}
                    y={flampX}
                />*/
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        drawingMode: state.globals.drawingMode,
        enableDebuging: state.globals.enableDebuging,
        enableTransparency: state.globals.enableTransparency,
        chamberRows: state.chamberbed.chamberRows,
        mainManifolds: state.mainManifolds.manifolds
    };
};

const mapDispatchToProps = {
    attachAccessory,
    getScaledValue
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(Flamp);



// WEBPACK FOOTER //
// ./src/components/Drawings/flamp.js